<template>
    <div>
        <!-- Company Mismatch Warning -->
        <div v-if="showCompanyMismatchWarning" class="text-center mt-12">
            <p class="error--text" style="font-size: 1.1rem;" v-html="$t('lang_GENERIC_CONTRACTS_MESSAGE_WARNING_CONTRACT_BELONGS_TO_OTHER_COMPANY', [contractDetails.contractName, contractDetails.alvId, contractDetails.contractType, contractDetails.connectedCompanyName]).replace(/\\n/g, '<br>')"></p>
        </div>
        <!-- Normal Edit Form -->
        <BaseEditPage v-else
            :context="context"
            :alvqa="alvqa"
            cancelIconRoute="/contracts/label"
        >
<!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div :alvqa="alvqa + '-title'">
                {{ data.contractName ? data.contractName : $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') }}
            </div>
        </template> 

<!-- EDIT FORM -->   
        <template v-slot:editForm>
            <!-- 1st column -->
            <!-- <v-col cols="2">
                <v-row>
                    <v-col>
                        <v-img
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <BaseIcon 
                                    @click="uploadCover()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_BUTTON_UPLOAD_FILE"
                                />
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>  
            </v-col> -->

            <!-- 2nd column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField
                        :context="context"
                        field="ContractName"
                        :label="contractNameLabel" 
                        rules="required"
                        :alvqa="alvqa + '-textfield-contract-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Type"
                        :items="contractTypes" 
                        :label="contractTypeLabel" 
                        rules="required"
                        :alvqa="alvqa + '-dropdown-contract-type'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="Licensor"
                        :label="licensorAZLabel"
                        rules="required"
                        :withFreeText="false"
                        :alvqa="alvqa + '-autocomplete-licensor-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-licensor-selection'">
                                <!-- {{ item.gemaName }}
                                <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                </span> -->
                                {{ $alvPlugin.showNameOfAzEntry(item) }}
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId + '-title'">
                                    <!-- {{ items.gemaName }}
                                    {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}} -->
                                    {{ $alvPlugin.showNameOfAzEntry(items) }}
                                    <!--  
                                        typeOfAz:
                                            allowed values: P, D or G
                                            P => Person => P in circle
                                            D => Distributor => D in circle (in german V for 'Vertrieb')
                                            G => Group => G in circle
                                        -->
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                        <!-- TODO: check i18n {{ i18n.locale === 'de' && items.item.typeOfAz === 'D' ? 'V' : items.item.typeOfAz }} -->
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== null && items.ipi !== "" && items.ipi !== undefined ? items.ipi : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }} | {{ items.alvId }}                                      
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-row>
                 <v-row>
                    <BaseEditPageTextarea 
                        :context="context"
                        field="Notes"
                        rows="3"
                        :label="notesLabel"
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
            </v-col>

            <!-- 3rd column -->
            <v-col>
                <v-row>
                    <BaseEditPageTextField
                        :context="context"
                        field="AlvId"
                        :label="contractIdLabel"
                        :clearable="false"
                        :readonly="true" 
                        :alvqa="alvqa + '-textfield-alvid'"
                    />
                </v-row>
                <v-row>
                    <!-- IDEA: rule for only numbers? -->
                    <BaseEditPageTextField
                        :context="context"
                        rules='positiveOrNegativeWithMaxTwoDigits'
                        field="InitialBalance"
                        :label="initialBalanceLabel"
                        :alvqa="alvqa + '-textfield-initial-balance'"
                    />
                </v-row>
                <v-row class="ml-1 mr-1">
                    <BasePeriod 
                        :context="context" 
                        widthYearField="4"
                        widthTimeUnitField="5"
                        widthNumberField="3"
                        :clearable="true"
                        periodLabel="lang_CONTRACTS_LABEL_CAPTION_INITIAL_BALANCE_PERIOD"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Tags"
                        :label="$t('lang_GENERIC_CAPTION_TAGS')"
                        :iconTooltipText="$t('lang_GENERAL_INFO_MESSAGE_WHITE_SPACE_SEPARATED')"
                        :alvqa="alvqa + '-textfield-tags'"
                    />
                </v-row>
            </v-col>

            <!-- 4th column -->
            <v-col>
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ContractDate"
                        :label="contractDateLabel"
                        rules="required"
                        :alvqa="alvqa + '-datepicker-contract-date'"
                    />
                </v-row>   
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ValidFrom"
                        :label="validFromLabel"
                        :alvqa="alvqa + '-datepicker-valid-from'"
                    />
                </v-row>  
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ValidUntil"
                        :label="validUntilLabel"
                        :alvqa="alvqa + '-datepicker-valid-until'"
                    />
                </v-row>  
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ReminderDate"
                        :label="reminderDateLabel"
                        :alvqa="alvqa + '-datepicker-reminder-date'"
                    />
                </v-row>
            </v-col>
            
            <v-col cols="2">
                <v-row> 
                    <BaseEditPageTextField
                        :context="context"
                        field="Reserve"
                        :label="reserveLabel" 
                        suffix="%"
                        :alvqa="alvqa + '-textfield-reserve'"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageDropdown 
                        :context="context"
                        field="ResolutionPeriod"
                        :items="resolutionPeriods" 
                        :label="resolutionPeriodLabel"
                        :alvqa="alvqa + '-dropdown-resolution-period'"
                    />
                </v-row>  
                <v-row> 
                    <BaseEditPageDropdown 
                        :context="context"
                        field="BillingCycle"
                        :items="billingCycles" 
                        :label="billingCycleLabel" 
                        :alvqa="alvqa + '-dropdown-billing-cycle'"
                    />  
                </v-row>
            </v-col>
        </template>

        <template v-slot:panels>
            <DeletionDialog :useContextSetinVuex="true" />
            <!-- SPLITS Panel -->
            <LabelContractsSplitsEditPanel />
            <LabelContractsSplitsEditPanelDialog />
            
            <!-- TRACKS/RELEASES Panel -->
            <TracksReleasesEditPanel />
            <TracksReleasesEditPanelDialog />
            <SearchDialog
                    :context="context"
                    subcontext="Releases" 
                    searchcontext="ReleasesForContract"
                    addcontext="ReleasesToContract"
                    addButtonLabel="lang_CONTRACTS_LABEL_ADD_RELEASES_DIALOG_BUTTON_ADD_RELEASES"
                    dialogTitle="lang_CONTRACTS_LABEL_ADD_RELEASES_DIALOG_TITLE"
            >
                    <template v-slot:itemTitle="{ item }">
                        {{ item.name }}
                    </template>
                    <template v-slot:itemSubtitle="{ item }">
                        EAN: {{ item.ean !== null ? item.ean : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }} | 
                        {{ $t('lang_GENERIC_CAPTION_CATALOGUE_NUMBER') }}: {{ item.catalogueNumber !== null ? item.catalogueNumber : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }} |
                        {{ $t('lang_LABEL_RELEASE_CAPTION_FIRST_MAIN_ARTIST') }}: {{ item.performer !== null ? $alvPlugin.getArtistOrPerformerName(item.performer) : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }}
                    </template>
            </SearchDialog>

            <!-- ADVANCE -->
            <LabelContractsAdvanceEditPanel />
            <LabelContractsAdvanceEditPanelDialog />

            <!-- RESERVES -->
            <LabelContractsReservesEditPanel />
            <LabelContractsReservesEditPanelDialog />

            <!-- COSTS -->
            <LabelContractsCostsEditPanel />
            <LabelContractsCostsEditPanelDialog />
            
            <!-- MEDIA -->
            <LabelContractsMediaEditPanel />
            <MediaFileUploadDialog
                acceptedFiles='.png,.jpg,.jpeg,.pdf,.txt,.wav,.mp3,.flac,.zip'
                placeholder="lang_GENERIC_CAPTION_SELECT_FILES_FOR_UPLOAD"
                headline="lang_GENERAL_FILE_IMPORT_DIALOG_TITLE_UPLOAD_FILE" 
                :context="context + 'Media'"
                detailsCall="getLabelContractsDetails"
                directory="contracts/label/"
            />
        </template>
    </BaseEditPage>
    </div>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BasePeriod from '@/components/_base/BasePeriod'


import TracksReleasesEditPanel from './_panels/2_tracks/TracksReleasesEditPanel'
import LabelContractsSplitsEditPanel from './_panels/1_splits/LabelContractsSplitsEditPanel'
import LabelContractsAdvanceEditPanel from './_panels/3_advance/LabelContractsAdvanceEditPanel'
import LabelContractsReservesEditPanel from './_panels/4_reserves/LabelContractsReservesEditPanel'
import LabelContractsCostsEditPanel from './_panels/5_costs/LabelContractsCostsEditPanel'
import LabelContractsMediaEditPanel from './_panels/6_media/LabelContractsMediaEditPanel'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import EditingDialog from '@/components/_dialogs/EditingDialog'
import TracksReleasesEditPanelDialog from './_panels/2_tracks/TracksReleasesEditPanelDialog'
import LabelContractsSplitsEditPanelDialog from './_panels/1_splits/LabelContractsSplitsEditPanelDialog'
import SearchDialog from '@/components/_dialogs/SearchDialog'
import LabelContractsAdvanceEditPanelDialog from './_panels/3_advance/LabelContractsAdvanceEditPanelDialog'
import LabelContractsReservesEditPanelDialog from './_panels/4_reserves/LabelContractsReservesEditPanelDialog'
import LabelContractsCostsEditPanelDialog from './_panels/5_costs/LabelContractsCostsEditPanelDialog'
import {DropdownLabelContractsContractTypes,
        DropdownLabelContractsBillingCycles,
        DropdownLabelContractsResolutionPeriods
} from '@/assets/dropdowns/alvDropdowns.js'
import MediaFileUploadDialog from '@/components/_dialogs/MediaFileUploadDialog'

export default {
    name: "LabelContractsEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        BaseEditPageTextField,
        BaseEditPageTextarea,
        BaseEditPageDropdown,
        BaseEditPageDatePicker,
        BasePeriod,
        BaseEditPageAutocomplete,

        TracksReleasesEditPanel,
        LabelContractsSplitsEditPanel,
        LabelContractsAdvanceEditPanel,
        LabelContractsReservesEditPanel,
        LabelContractsCostsEditPanel,

        DeletionDialog,
        EditingDialog,
        TracksReleasesEditPanelDialog,
        LabelContractsSplitsEditPanelDialog,
        LabelContractsAdvanceEditPanelDialog,
        LabelContractsReservesEditPanelDialog,
        LabelContractsCostsEditPanelDialog,
        SearchDialog,
        MediaFileUploadDialog,
        LabelContractsMediaEditPanel
    },
    data() {
        return {
            context: "LabelContracts",
            alvqa: "contracts-label-edit-form"
        }
    },
    computed: {
        contractDetails() { 
            return this.$store.getters.getLabelContractsDetails 
        },
        selectedLabelCompanyAlvId() {
            const companyData = this.$store.getters.getSelectedLabelCompanyId
            if (!companyData) return null
            const id = typeof companyData === 'object' ? companyData.id : companyData
            return 'ALV' + String(id).padStart(9, '0') + 'LC'
        },
        showCompanyMismatchWarning() {
            const details = this.contractDetails
            if (!details || !details.connectedCompanyAlvId) return false
            if (details.alvId !== this.$route.params.alvId) return false
            return details.connectedCompanyAlvId !== this.selectedLabelCompanyAlvId
        },
        contractNameLabel() { return this.$t('lang_GENERIC_CONTRACTS_CONTRACT_TITLE') },
        contractIdLabel() { return this.$t('lang_CAPTION_ALVID') },
        contractTypeLabel() { return this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_TYPE') },
        contractDateLabel() { return this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_DATE') },
        reminderDateLabel() { return this.$t('lang_CONTRACTS_LABEL_ALERT_ON') },
        notesLabel() { return this.$t('lang_GENERAL_CAPTION_NOTES') },
        validFromLabel() { return this.$t('lang_CONTRACTS_LABEL_CAPTION_VALID_FROM') },
        validUntilLabel() { return this.$t('lang_CONTRACTS_LABEL_CAPTION_VALID_UNTIL') },
        reserveLabel() { return this.$t('lang_LABEL_CONTRACTS_CAPTION_RESERVE') },
        resolutionPeriodLabel() { return this.$t('lang_LABEL_CONTRACTS_CAPTION_RESERVE_SETTLE') },
        billingCycleLabel() { return this.$t('lang_CONTRACTS_LABEL_CAPTION_STATEMENT_SCHEDULE') },
        initialBalanceLabel() { return this.$t('lang_CONTRACTS_LABEL_CAPTION_INITIAL_BALANCE') },
        licensorAZLabel() { return this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACTING_PARTY') },
        initialBalancePeriodLabel() { return this.$t('lang_CONTRACTS_LABEL_CAPTION_INITIAL_BALANCE_PERIOD') },

        resolutionPeriods() {
            return DropdownLabelContractsResolutionPeriods
        },
        billingCycles() {
            return DropdownLabelContractsBillingCycles
        },
        contractTypes() {
            return DropdownLabelContractsContractTypes
        }
    },
    watch: {
        '$i18n.locale': {
            handler(newLocale) {
                const initialBalanceValue = this.$store.state.labelContracts.labelContractsDetails.initialBalance;

                if (initialBalanceValue) {
                    const formattedValue = newLocale === 'de' ?
                        initialBalanceValue.replaceAll('.', ',').replace(',', '.') :
                        initialBalanceValue.replaceAll(',', '.').replace('.', ',');

                    this.$store.commit('setLabelContractsDetailsInitialBalance', formattedValue);
                }
            },
            immediate: true
    }
  }
}
</script>